import React, { useMemo } from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import TextField from 'libs/formik_fields/TextField';

import { useFormikContext } from 'formik';
import DateInputField from '../../libs/formik_fields/DateInputField';
import RadioGroupField from '../../libs/formik_fields/RadioGroupField';
import SelectField from '../../libs/formik_fields/SelectField';

function QuestionField({ question, sno, index, students }) {
    const formik = useFormikContext();
    const inputDataLength = useMemo(() => {
        const text = formik.values?.questions[index]?.answerText ?? '';
        return text.length;
    }, [formik.values, index]);
    return (
        <Grid container spacing={2} key={index}>
            {question.optionType === 'STUDENT' && students.length > 0 && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h4">
                            {`${sno}.`} {question.question}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SelectField
                            fullWidth
                            size="small"
                            name={`questions[${index}].answerId`}
                            label="Answer"
                            showErrorText={false}
                            options={students}
                            valueKey="_id"
                            labelKey="name"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </>
            )}
            {question.optionType === 'MANUAL' && question.pollQuestionOptions.length > 0 && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h4">
                            {`${sno}.`} {question.question}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SelectField
                            fullWidth
                            size="small"
                            name={`questions[${index}].answerId`}
                            label="Answer"
                            showErrorText={false}
                            options={question.pollQuestionOptions}
                            valueKey="_id"
                            labelKey="name"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </>
            )}
        </Grid>
    );
}

export default QuestionField;
